import React, { useEffect, useRef, useState } from "react";
import Plyr from "plyr-react";
import "plyr-react/plyr.css";
import { SessionKeys } from "../../../utils/AppUtils";
import CONFIG from "../../../utils/config";
const AudioPlayer = ({ src, moduleId, courseId, watch_time }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  let currentTime = 0;
  let duration = 0;

  const togglePlay = () => {
    const audio = audioRef.current;
    if (audio.paused) {
      audio.play();
      setIsPlaying(true);
    } else {
      audio.pause();
      setIsPlaying(false);
    }
  };

  const handleTimeUpdate = () => {
    const audio = audioRef.current;
    setProgress((audio.currentTime / audio.duration) * 100);
  };

  const handleProgressChange = (e) => {
    const audio = audioRef.current;
    const value = e.target.value;
    audio.currentTime = (audio.duration / 100) * value;
    setProgress(value);
  };

  const [srcUrl, setSrcUrl] = useState(src);
  useEffect(() => {
    console.log("audio url", src);
    setSrcUrl(src);
  }, [src]);

  useEffect(() => {
    const startTime = watch_time; // Start at 30 seconds

    const interval = setInterval(() => {
      const player = audioRef.current?.plyr;
      if (player && srcUrl&&audioRef ) {
        player.currentTime = startTime; // jump to specific time
        console.log("startTime1: ", startTime,audioRef);
    
        // player.play();
        clearInterval(interval);
      }
    }, 1000); // Check every 500ms

    return () => clearInterval(interval);
  }, [srcUrl,audioRef,watch_time]);

  useEffect(() => {
    const interval = setInterval(() => {
      const plyr = audioRef.current?.plyr;
      if (plyr && typeof plyr.currentTime === "number") {
        currentTime = parseInt(plyr.currentTime);
        duration = parseInt(plyr.duration);
        sessionStorage.setItem("currentAudio",currentTime);
        sessionStorage.setItem("currentDuration",duration);
        console.log(currentTime, duration);
      }
    }, 1000); // updates every half second

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      callSaveProgressApi();
    }, 10000);
    return () => {
     callSaveProgressApi();
     clearInterval(interval);
    };
  }, []);

  const callSaveProgressApi = () =>{

     // Replace with your actual token logic
      const token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
      // Use the latest currentTime and duration values

      if(sessionStorage.getItem("currentAudio")===null || sessionStorage.getItem("currentAudio")===undefined || sessionStorage.getItem("currentAudio")==="0"){
        return;
      }
      const payload = {
        token,
        course_id: courseId,
        module_id: moduleId,
        watch_time: parseInt(sessionStorage.getItem("currentAudio")),
        duration: parseInt(sessionStorage.getItem("currentDuration")),
      };
      console.log("currentTimeOnBack", currentTime, duration);
      sessionStorage.removeItem("currentAudio");
        // sessionStorage.removeItem("currentDuration");

      fetch(CONFIG.API_URL_REAL_BROKER + "wp-json/finwell/v1/save-progress", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Progress saved:", data);
        })
        .catch((err) => {
          console.error("Error saving progress:", err);
        });

  }

  useEffect(() => {
    console.log("watch_time ", watch_time);
    // if(watch_time>0){
    // const plyrInstance = audioRef.current?.plyr;
    // if (plyrInstance) {
    //   plyrInstance.currentTime = 10; // seek to 10 seconds
    // }
    // }
  }, []);

  return (
    // <div style={{ width: "300px", padding: "10px", border: "1px solid #ccc", borderRadius: "8px" }}>
    //   <audio ref={audioRef} src={src} onTimeUpdate={handleTimeUpdate} />
    //   <button onClick={togglePlay}>
    //     {isPlaying ? "Pause" : "Play"}
    //   </button>
    //   <input
    //     type="range"
    //     value={progress}
    //     onChange={handleProgressChange}
    //     style={{ width: "100%" }}
    //   />
    // </div>
    <>
      {srcUrl ? (
        <Plyr
          ref={audioRef}
          source={{
            type: "audio",
            sources: [
              {
                //src: '{src}',
                src: srcUrl,
                type: "audio/mp3",
              },
            ],
          }}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default AudioPlayer;
